import React from "react";
import Slider from "../components/Slidbar/Slidbar";
import Tabel from "../components/JobTitle/Tabel";

export const JobTitle = () => {
  return (
    <>
      <Slider />
      <Tabel />
    </>
  );
};
